/* proxies */
import NegativeProxy from '../../proxies/Negative/NegativeProxy';

export default {
  data() {
    return {
      updatingData: {},
    };
  },
  methods: {
    updateSimpleRequest(negative, property) {
      return (value) => {
        const data = {};
        data[property] = value;
        // console.warn(negative);
        this.updatingData[negative.uuid] = true;
        this.$forceUpdate();
        return new NegativeProxy().update(negative.uuid, data)
          .then((response) => {
            negative[property] = response.data.data.negative[property];
          })
          .finally(() => {
            delete this.updatingData[negative.uuid];
            this.$forceUpdate();
          });
      };
    },
  },
};
